/**
 * Entrée par jeton (chantier QR-code séance, 2026-09-04) : le pur, testable
 * sans écran. Le QR projeté contient `/scan/<id>#<jeton>` ; le jeton est dans
 * le FRAGMENT, que le navigateur n'envoie jamais au serveur : rien dans les
 * journaux du routeur, rien dans l'historique une fois la barre nettoyée.
 */

/** Le jeton porté par le fragment de l'adresse, ou null. 256 bits en
 *  base64 URL font 43 caractères ; on accepte large mais jamais n'importe quoi. */
export const lireJetonFragment = (hash) => {
    const brut = String(hash || '');
    const valeur = brut.startsWith('#') ? brut.slice(1) : brut;
    return /^[A-Za-z0-9_-]{16,128}$/.test(valeur) ? valeur : null;
};

/** Un message par refus du serveur (codes de scan_appareil), en langue de prof. */
const MESSAGES = {
    jeton_inconnu: {
        titre: 'Lien expiré',
        texte: 'Le QR projeté change toutes les deux minutes. Rescannez l\'écran.',
    },
    deja_reclame: {
        titre: 'Ce lien a déjà servi',
        texte: 'Un appareil est déjà relié avec ce QR. Détachez-le depuis l\'écran projeté, puis rescannez.',
    },
    appareil_deja_relie: {
        titre: 'Un appareil est déjà relié',
        texte: 'Un autre téléphone pilote cette séance. Détachez-le depuis l\'écran projeté, puis rescannez.',
    },
    trop_essais: {
        titre: 'Trop d\'essais',
        texte: 'Patientez une minute, puis rescannez l\'écran projeté.',
    },
    detache: {
        titre: 'Appareil détaché',
        texte: 'Cet appareil ne pilote plus la séance. Rescannez l\'écran projeté pour la reprendre.',
    },
    expire: {
        titre: 'Connexion expirée',
        texte: 'Le serveur ne reconnaît plus ce téléphone. Sur l\'écran projeté, cliquez sur « Détacher le téléphone », puis rescannez le QR.',
    },
    defaut: {
        titre: 'Connexion impossible',
        texte: 'Vérifiez le réseau, puis rescannez l\'écran projeté.',
    },
};

export const messageRefus = (code, statut) => {
    if (statut === 429) return MESSAGES.trop_essais;
    return MESSAGES[code] || MESSAGES.defaut;
};

/** Les participants d'un `question_change` du flux, dans la forme que la vue
 *  scan attend. Sous jeton le serveur a déjà remplacé les noms par « Carte N » ;
 *  sur le PC ils arrivent en clair. La vue ne fait pas la différence. */
export const assignationsDepuisParticipants = (participants) => (
    Array.isArray(participants)
        ? participants
            .filter((p) => p && p.code_aruco !== undefined && p.code_aruco !== null)
            .map((p) => ({ codeAruco: Number(p.code_aruco), eleveNom: p.nom || `Carte ${p.code_aruco}`, prenom: null }))
            .sort((a, b) => a.codeAruco - b.codeAruco)
        : []
);
